export default "__VITE_ASSET__7b1e4516__"